import { render, staticRenderFns } from "./CustomFormRecordRecipients.vue?vue&type=template&id=159b5ea8"
import script from "./CustomFormRecordRecipients.js?vue&type=script&lang=js&external"
export * from "./CustomFormRecordRecipients.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormRecordRecipients.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports